import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { App as AntdApp, ConfigProvider, message } from "antd";
import { themeProps } from "@alphascriptsolutions/client-core";
import "../../styles/globals.css";
import App from "./App";

function getPresentationMountEl(): HTMLElement {
  return document.getElementById("presentationRoot") ?? document.body;
}

/** Mount inside the dialog root so Office iframes don’t clip antd portals. */
message.config({
  duration: 4,
  maxCount: 4,
  top: 16,
  getContainer: getPresentationMountEl,
});

const rootElement: HTMLElement | null = document.getElementById("presentationRoot");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <ConfigProvider
      theme={{
        ...themeProps,
        token: {
          ...themeProps.token,
          fontSize: 13,
        },
      }}
    >
      <AntdApp>
        <FluentProvider theme={webLightTheme}>
          <App />
        </FluentProvider>
      </AntdApp>
    </ConfigProvider>
  );
});
